import { FCWithChildren } from '@types';
import React, { useEffect } from 'react';

import { AutocompleteInput, AutocompleteInputFormatPattern as FormatPattern } from '@components';

const MAC_FORMATS: FormatPattern[] = [
  { test: /^[A-F0-9]{3}/i, template: '************' },
  { test: /^[A-F0-9]{2}-/i, template: '**-**-**-**-**-**' },
  { test: () => true, template: '**:**:**:**:**:**' },
];

type MACAddressInputProps = {
  clearInput?: boolean;
  control?: any;
  register: any;
  nextFocus?: () => void;
  focusMACInput?: boolean;
  setFocusMACInput?: () => void;
  id?: string;
  inputClassName?: string;
};

type objReferenceType = Record<string, React.RefObject<any> | null | undefined>;

const MACAddressInput: FCWithChildren<MACAddressInputProps> = ({
  clearInput,
  register,
  nextFocus,
  focusMACInput,
  setFocusMACInput,
  id,
  inputClassName,
}) => {
  let objRefs: objReferenceType = {};

  useEffect(() => {
    if (focusMACInput) {
      (objRefs['macAddress'] as any)?.focus();
      setFocusMACInput && setFocusMACInput();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusMACInput, setFocusMACInput]);

  const onKeyDownHandler = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const { key, shiftKey } = e;

    if (!shiftKey && key === 'Tab') {
      e.preventDefault();
      nextFocus && nextFocus();
      return;
    }
  };

  return (
    <div>
      <input autoComplete="false" name="hidden" type="text" className="hidden" />
      <div>
        <AutocompleteInput
          id={id}
          formats={MAC_FORMATS}
          clearInput={clearInput}
          autoComplete="off"
          className={inputClassName}
          maxLength={17}
          onKeyDown={onKeyDownHandler}
          {...register('macAddress')}
        />
      </div>
    </div>
  );
};

export default MACAddressInput;
